import React from 'react';
import './Referral.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/system';
import { dateFormat, showEmail, showPhone } from '../../../core/helper/date-format';
import KycStatusComp from '../../../Pages/separate/kycStatusComp';
import Loader from '../../../Component/Loader/Loader';

const StyledTableHeadRow = styled(TableCell)(({ theme }) => ({
    borderBottom: 'none',
    fontFamily: 'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"',
    fontSize: "22px",
    fontWeight: "500",
    fontStyle: "normal",
    padding: "5px",
    paddingBottom: "16px",
    width: "auto !important",
    color: "white",
    textAlign: 'center'
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    borderBottom: 'none',
    fontFamily: 'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"',
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "27px",
    padding: "5px",
    width: "auto !important",
    color: "white",
    textAlign: 'center'
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
    borderBottom: 'none',
    fontFamily: 'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"',
    fontSize: "32px",
    fontWeight: "600",
    padding: "5px",
    fontStyle: "normal",
    lineHeight: "38px",
    width: "auto !important",
    color: "white",
    textAlign: 'center'
}));


const ReferralFriend = ({ referralData, loading }) => {
    return (
        <div className='my-2'>
            {loading ? <Loader /> :
                <TableContainer>
                    <Table sx={{ minWidth: window.innerWidth < 700 ? 700 : 100, justifyContent: 'center' }} aria-label="simple table">
                        <StyledTableHead>
                            <TableRow>
                                <StyledTableHeadRow>Date</StyledTableHeadRow>
                                <StyledTableHeadRow>Email</StyledTableHeadRow>
                                <StyledTableHeadRow>Phone</StyledTableHeadRow>
                                <StyledTableHeadRow>KYC Status</StyledTableHeadRow>
                            </TableRow>
                        </StyledTableHead>
                        <TableBody>
                            {referralData && referralData.referUsers && referralData.referUsers.length > 0 && referralData.referUsers.map((referUsers) => {
                                return (
                                    <TableRow key={referUsers.email}>
                                        <StyledTableCell component="th" scope="row">{dateFormat(referUsers.registerOn)}</StyledTableCell>
                                        <StyledTableCell>{showEmail(referUsers.email)}</StyledTableCell>
                                        <StyledTableCell>{showPhone(referUsers.phoneno)}</StyledTableCell>
                                        <StyledTableCell> <KycStatusComp
                                            status={referUsers.kycstatus}
                                        /></StyledTableCell>
                                    </TableRow>
                                )
                            }
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            <div className='text-center'>
                {referralData && referralData.referUsers && referralData.referUsers.length == 0 && !loading && <p className='color-white f-13 m-top-20'>No Records Found!</p>}
            </div>
        </div>
    );
};

export default ReferralFriend;